<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="indexItems"
    :maskFields="maskFields"
    :infoHeaders="infoHeaders"
    @options-change="optionsChange"
    :serverItemsLength="totalItems"
    :loadOptions="options"
    :enableCustomFilters="true"
    :containTopToolbar="false"
    :typeOperators="typeOperators"
    :serverFields="serverFields"
    @filter-confirm-action="applyFilters"
  >
    <template slot="new" v-if="$can('create', $router.currentRoute.name)">
      <New
        @entry-created="entryCreated"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="show" slot-scope="{ item }" v-if="$can('read', $router.currentRoute.name)">
      <Edit
        :entry="item"
        :readOnly="true"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="edit" slot-scope="{ item }" v-if="$can('update', $router.currentRoute.name)">
      <Edit
        :entry="item"
        @entry-updated="entryUpdated"
        v-if="item.statusKey != 'realized'"
        :modelNameSingular="modelNameSingular"
        :isEdit="true"
      />
    </template>

    <template slot="delete" slot-scope="{ item }" v-if="$can('delete', $router.currentRoute.name)">
      <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="action1" slot-scope="{ item }">
      <ExecutionOperationNew
        :planningOperation="item"
        :inlineAddButton="true"
        newCreateButtonLabel="Realizar operação"
        @entry-created="executionOperationCreated"
        v-if="item.statusKey == 'not_realized'"
        modelNameSingular="Operação"
      />
    </template>

    <template v-if="item.statusKey == 'realized' && item.executionOperationId" slot="link1" slot-scope="{ item }">
      <ExecutionOperationEdit
        :entry="{id: item.executionOperationId}"
        @entry-updated="executionOperationUpdated"
        :editTitle="'Operação ' + item.executionOperationCode"
        editIcon="mdi-tractor"
        :isTextButton="true"
        :textButton="item.executionOperationCode"
        modelNameSingular="Operação"
      />
    </template>

  </BaseIndex>
</template>

<script>
import gql from 'graphql-tag'
import BaseIndex from "@shared_components/base_index.vue";
import New from "./new.vue";
import Edit from "./edit.vue";
import Delete from "./delete.vue";
import ExecutionOperationNew from "../execution_operations/new.vue"
import ExecutionOperationEdit from "../execution_operations/edit.vue"

export default {
  data() {
    return {
      indexItems: [],
      loading: true,
      pageLoading: false,
      totalItems: 0,
      tableHeaders: [
        { text: "Código", align: "left", sortable: true, value: "code"},
        { text: "Tipo de Operação", align: "left", sortable: true, value: "operationType.name"},
        { text: "Ciclo(s)", align: "left", sortable: true, value: "periodsNamesList"},
        { text: "Talhão(ões)", align: "left", sortable: true, value: "periodsFields"},
        { text: "Safra(s)", align: "left", sortable: true, value: "periodsHarvests"},
        { text: "Cultura(s)", align: "left", sortable: true, value: "periodsCultures"},
        { text: "Área Total", align: "left", sortable: true, value: "periodsTotalArea" },
        { text: "Data da Operação", align: "left", sortable: true, value: "operationDate" },
        { text: "Duração Total", align: "left", sortable: true, value: "activitiesTotalDuration" },
        { text: "Operação", align: "left", sortable: false, value: "link" },
        { text: "Status", align: "left", sortable: true, value: "status" },
        { text: "Ações", align: "left", sortable: false, value: "action" }
      ],
      // maskFields: [
        // { field: 'operationDate', mask: 'date'},
        // { field: 'periodsNamesList', mask: 'tag', color: 'success', outlined: true }, 
        // { field: 'periodsTotalArea', mask: 'number_unit', unit: 'ha' },
      // ],
      infoHeaders: [],
      options: { //objeto específico para configurar e armazenar as informações da paginação e ordenação.
        page: 1,
        itemsPerPage: 10,
        sortBy: ["code"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      },
      filters: [], //array para armazenar os filtros inseridos pelo usuário
      typeOperators: [], //array que traz do banco os operadores que serão utilizados nos filtros
      serverFields: [], // array que traz do banco quais os campos que podem ser aplicados filtros
    };
  },
  props: {
    modelNameSingular: {
      type: String,
      default: "Operação Planejada"
    },
    modelNamePlural: {
      type: String,
      default: "Operações Planejadas"
    },
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
    ExecutionOperationNew: ExecutionOperationNew,
    ExecutionOperationEdit: ExecutionOperationEdit
  },
  created() {
    //this.loadServerEntries();
  },
  computed: {
    maskFields() {
      return [
        { field: 'operationDate', mask: 'date'},
        ... this.$vuetify.breakpoint.smAndDown ? [] : [{ field: 'periodsNamesList', mask: 'tag', color: 'success', outlined: true }], 
        { field: 'periodsTotalArea', mask: 'number_unit', unit: 'ha' },
        { field: 'status', mask: 'status_color', colorField: 'statusColor' },
      ]
    }
  },
  methods: {
    applyFilters: function(filtersList) {
      this.filters = filtersList;
      this.options.page = 1;
      this.loadServerEntries();
    },
    loadServerEntries: function() {
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_ALL_PLANNING_OPERATIONS,
          variables: {
            input: { //todo index com paginação, ordenação e filtros server-side precisa enviar essas informações quando fizer a busca por dados
              limit: this.options.itemsPerPage,
              offset: (this.options.page - 1) * this.options.itemsPerPage,
              sortBy: this.options.sortBy,
              sortDesc: this.options.sortDesc,
              fields: this.tableHeaders.map(val => val.sortable ? (val.filter_value ? val.filter_value : val.value) : null)?.filter(val => val != null),
              filters: this.filters
            }
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          // this.executionOperations = response.data.groundContext.allExecutionOperations;
          // console.log("All planningOperations", response.data.groundContext.planningOperationsIndex);
          this.indexItems = response.data.groundContext.planningOperationsIndex.operationViewIndexFilters; //seta os itens retornados do servidor para o array de itens que será exibido na tabela
          this.totalItems = response.data.groundContext.planningOperationsIndex.count; // seta o numero total de itens, como a paginação limita a quantidade de itens, o componente precisa saber qual o máximo de itens para configurar o componente na interface e calcular o número de páginas 
          this.typeOperators = response.data.groundContext.planningOperationsIndex.typeOperators; //seta os operadores que podem ser utilizados nos filtros
          this.serverFields = response.data.groundContext.planningOperationsIndex.serverFields; // seta os campos que podem ser filtrados
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    entryUpdated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    executionOperationCreated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationMessage("Operação realizada com sucesso!");
    },
    entryDeleted: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
    executionOperationUpdated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationMessage("Operação realizada atualizada com sucesso!");
    },
    optionsChange: function(opts) {
      this.options = opts;
      this.loadServerEntries();
    },
  }
};

const LOAD_ALL_PLANNING_OPERATIONS = gql `
  query($input: IndexInputObject!) {
    groundContext {
      planningOperationsIndex(input: $input){
        count
        typeOperators
        serverFields      
        operationViewIndexFilters {
          id
          code
          status
          statusKey
          statusColor
          executionOperationId  
          executionOperationCode                  
          operationDate
          periodsFields
          periodsCultures
          periodsHarvests
          periodsNamesList
          periodsTotalArea
          activitiesTotalDuration
          operationTypeId
          operationType {
            id
            name
            operationOrder
          }
          periodIds
          periodIdsAttribute
          periods {
            id
            name
            culture {
              id
              name
            }
            field {
              id
              name
            }
            harvest {
              id
              name
            }
          }
          observation
          canBeDeleted
          undeletabilityReasons
        }
      }
    }
  }
`;

</script>

<style scoped></style>
